import { publishAllFeatureStates } from '@sb/features';
import DeviceDetector from '../components/DeviceDetector';

const EMPTY_FEATURE_FLAGS_CONFIG = {
    features: {},
};

const FEATURE_FLAGS_CONFIG_CONTENT_TYPE = 'hrz_feature_flags_config';
const FEATURE_FLAGS_COMPOSITE_KEY = 'feature-flags-config';

const getEnvironmentUrlSuffix = (environment) => environment === 'pp1' ? '-pp1' : '';

const getContentStackBaseUrl = ({ environment, contentType }) =>
    `https://cs-sport${getEnvironmentUrlSuffix(environment)}.staticcache.org/v3/content_types/${contentType}/entries`;

const buildFeatureFlagsConfigUrl = ({ environment, compositeKey }) => {
    const baseUrl = getContentStackBaseUrl({
        environment,
        contentType: FEATURE_FLAGS_CONFIG_CONTENT_TYPE,
    });
    const query = JSON.stringify({ composite_key: compositeKey });
    const params = new URLSearchParams({ query });

    return `${baseUrl}?${params.toString()}`;
};

const fetchFeatureFlagsConfig = (params) =>
    fetch(buildFeatureFlagsConfigUrl(params))
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Feature flags request failed: ${response.status}`);
            }

            return response.json();
        });

const transformResponseToFeaturesConfig = (response) => {
    const entry = response && response.entries && response.entries[0];

    if (!entry || !Array.isArray(entry.features)) {
        return EMPTY_FEATURE_FLAGS_CONFIG;
    }

    const features = {};

    entry.features.forEach((feature) => {
        const percentage = feature.config && feature.config[0] ? feature.config[0].percentage : 0;

        features[feature.key] = {
            pct: percentage,
        };
    });

    return { features };
};

const init = () => {
    const deviceData = DeviceDetector.getResult();
    const environment = deviceData && deviceData.environment;

    if (!environment) {
        publishAllFeatureStates(EMPTY_FEATURE_FLAGS_CONFIG);
        return Promise.resolve();
    }

    return fetchFeatureFlagsConfig({
        environment,
        compositeKey: `${environment}/${FEATURE_FLAGS_COMPOSITE_KEY}`,
    })
        .then((response) => publishAllFeatureStates(transformResponseToFeaturesConfig(response)))
        .catch(() => publishAllFeatureStates(EMPTY_FEATURE_FLAGS_CONFIG));
};

export default {
    init,
};
